import { AppError } from "./AppError";

//

export class NotFoundError extends AppError {
  public name = "NotFoundError";
}
